module.exports = __webpack_public_path__ + "html/img/soundmark_course_bg.75632ef2.png";